export default {
  cadastro: {}
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/store/state.js